import Project from "../components/project";

const Colorhub = () => {
  const images = {
    desktop: "projects/colorhub-desktop.png", // ภาพสำหรับ Desktop ในหน้านี้
    tablet: "projects/colorhub-tablet.png",   // ภาพสำหรับ Tablet
    mobile: "projects/colorhub-mobile.png",   // ภาพสำหรับ Mobile
  };

  return <Project images={images} />;
};

export default Colorhub;
